import { getAdminUser } from '@/hooks/useAdminAuth';
import { supabase } from '@/lib/supabase';

export type AdminRole = 'super_admin' | 'editor';

export function useAdminRole() {
  const user = getAdminUser();
  const role: AdminRole = user?.role ?? 'editor';
  const isSuperAdmin = role === 'super_admin';

  return { role, isSuperAdmin, user };
}

// Modules that only super_admin can access
export const SUPER_ADMIN_ONLY_PATHS = ['/admin/users', '/admin/logs'];

export function canAccessPath(path: string, role: AdminRole): boolean {
  if (SUPER_ADMIN_ONLY_PATHS.some((p) => path.startsWith(p))) {
    return role === 'super_admin';
  }
  return true;
}

// Write operation log
export async function writeLog(params: {
  module: string;
  action: string;
  target_name?: string;
  detail?: string;
}) {
  const user = getAdminUser();
  if (!user) return;
  await supabase.from('admin_operation_logs').insert({
    operator_username: user.username,
    operator_display_name: user.display_name,
    operator_role: user.role,
    module: params.module,
    action: params.action,
    target_name: params.target_name ?? '',
    detail: params.detail ?? '',
  });
}
